import { ReactNode } from "react";
import { IconX } from "../../icons";
import IconButton from "../IconButton";
import "./index.scss";

interface ModalPopUpProps {
  status: boolean;
  title?: string | ReactNode;
  text?: string | ReactNode;
  onClickCancel: (value: boolean) => void;
  children: ReactNode;
  className?: string;
  listRender?: any;
  classNameTitle?: string;
  classNameChildren?: string;
  classNameGrandson?: string;
}

export function ModalPopUp({ status, title, text, onClickCancel, children, className,classNameTitle, classNameChildren, classNameGrandson }: ModalPopUpProps) {
  return (
    <>
      {status && (
        <>
          <div className="bg-overlayModal modalPopUp-Overlay" onClick={() => onClickCancel(!status)}></div>
          <div className={`modalPopUp-Content ${className} `}>
            {title && <div className={`modalPopUpHeaderContainer title-modal ${classNameTitle}`}>{title}</div>}
            <IconButton className="iconX" icon={IconX} onClick={() => onClickCancel(!status)} />
            <div className={classNameChildren}>
              <div className="modalPopUpHeaderContainer">{text}</div>
              <div className={`modalPopUpBodyContainer ${classNameGrandson}`}>{children}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
